import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

export const inr = (n) => {
  if (n === null || n === undefined || Number.isNaN(Number(n))) return "₹0";
  const num = Number(n);
  return "₹" + num.toLocaleString("en-IN", { maximumFractionDigits: 0 });
};

export const monthLabel = (y, m) => {
  return new Date(y, m - 1, 1).toLocaleString("en-IN", { month: "long", year: "numeric" });
};

export const isoDate = (d) => {
  const dd = d instanceof Date ? d : new Date(d);
  const y = dd.getFullYear();
  const m = String(dd.getMonth() + 1).padStart(2, "0");
  const day = String(dd.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
};

// Quick date-range helpers (Today / Yesterday / This Week / This Month / Last Month / Custom)
const startOfWeek = (d) => {
  const x = new Date(d);
  const day = x.getDay(); // 0 Sun .. 6 Sat
  const diff = (day + 6) % 7; // make Monday start
  x.setDate(x.getDate() - diff);
  x.setHours(0,0,0,0);
  return x;
};
const endOfWeek = (d) => {
  const s = startOfWeek(d);
  const e = new Date(s);
  e.setDate(s.getDate() + 6);
  return e;
};
export const QUICK_RANGES = [
  { key: "today", label: "Today" },
  { key: "yesterday", label: "Yesterday" },
  { key: "this_week", label: "This Week" },
  { key: "this_month", label: "This Month" },
  { key: "last_month", label: "Last Month" },
  { key: "custom", label: "Custom Range" },
];

export const rangeFromKey = (key, today = new Date()) => {
  const t = new Date(today);
  if (key === "today") {
    return { from: isoDate(t), to: isoDate(t) };
  }
  if (key === "yesterday") {
    const y = new Date(t); y.setDate(y.getDate() - 1);
    return { from: isoDate(y), to: isoDate(y) };
  }
  if (key === "this_week") {
    const s = startOfWeek(t);
    return { from: isoDate(s), to: isoDate(endOfWeek(t)) };
  }
  if (key === "this_month") {
    const s = new Date(t.getFullYear(), t.getMonth(), 1);
    const e = new Date(t.getFullYear(), t.getMonth() + 1, 0);
    return { from: isoDate(s), to: isoDate(e) };
  }
  if (key === "last_month") {
    const s = new Date(t.getFullYear(), t.getMonth() - 1, 1);
    const e = new Date(t.getFullYear(), t.getMonth(), 0);
    return { from: isoDate(s), to: isoDate(e) };
  }
  return { from: null, to: null };
};

